var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('RevisionsList',{attrs:{"is-loading":_vm.isLoading,"revisions":_vm.revisionUiItems},on:{"revisionSelected":_vm.onRevisionSelected}})
}
var staticRenderFns = []

export { render, staticRenderFns }